import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { ModalPreset } from "@modules/+new/shared/universal-modal/entities/modal-preset.interface";
import { PendingData } from "@modules/+new/shared/universal-modal/components/_presets/pending-preset/entities/pending-data";
import { LastActivatedRoute } from "@modules/+new/shared/universal-modal/functions/last-activated-route.service";
import { interval, of, Subject, takeUntil } from "rxjs";
import { TransactionsFacade } from "@modules/+new/transactions/domain/+state/transactions.facade";
import { delay, startWith, switchMap, take, takeWhile } from "rxjs/operators";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";
import { Router } from "@angular/router";
import { FiatTransactionDepositResponse } from "@modules/shared/domain/entities/fiat-transaction-deposit-response.model";
import { HelpersService } from "@modules/+new/shared/universal-modal/components/_presets/helpers/helpers";

@Component({
	selector: "pending-preset",
	templateUrl: "./pending-preset.component.html",
	styleUrls: ["./pending-preset.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [HelpersService],
	standalone: false
})
export class PendingPresetComponent implements ModalPreset<PendingData>, OnInit {
	public data: PendingData = {};

	constructor(
		private readonly route: LastActivatedRoute,
		private readonly router: Router,
		private readonly transactionFacade: TransactionsFacade,
		private readonly helperService: HelpersService
	) {}

	ngOnInit(): void {
		const { pid, fpid } = this.route.getAllParams();
		this.data.transactionId = fpid;
		this.data.fiatWalletId = pid;
		this.fetchData();
	}

	private fetchData(): void {
		const stopPolling$ = new Subject();
		let currentStatus: FiatTransactionDepositResponse = null;
		//retrying every 5 seconds for 15 seconds
		interval(5000)
			.pipe(
				startWith(0),
				switchMap(() => this.transactionFacade.getDepositTransactionResponse$(this.data.transactionId)),
				takeWhile((res) => {
					//we continue if the status is still pending
					currentStatus = res;
					return res.payment_status === "pending";
				}),
				delay(15000),
				switchMap(() => {
					// after 15 sec we end the loop
					stopPolling$.next(true);
					return of({});
				}),
				takeUntil(stopPolling$),
				take(1)
			)
			.subscribe({
				complete: () => {
					const baseUrl = `fiat-wallet/${this.data.fiatWalletId}/transaction/${this.data.transactionId}`;
					if (currentStatus.payment_status !== "pending") {
						//if status is not pending then we redirect to the specific screens
						this.helperService.redirect(currentStatus, baseUrl);
					} else {
						//if status is still pending we redirect to the taking longer screen
						this.router.navigateByUrl(
							`deposit/${baseUrl}/${currentStatus.payment_status}(${ROUTER_OUTLET_NAME}:status/pending-taking-longer)`
						);
					}
				}
			});
	}
}
